import React from 'react';
import PropTypes from 'prop-types';
import useDebounce from 'Hooks/useDebounce';
import { noop } from 'Helpers/PropTypes';
import BigHierarchyMultipicklistLegacy
  from 'Components/ComponentLibrary/Components/Inputs/Multipicklist/BigHierarchyMultipicklistControl/BigHierarchyMultipicklistLegacy';
import BigHierarchyMultipicklistNew
  from 'Components/ComponentLibrary/Components/Inputs/Multipicklist/BigHierarchyMultipicklistControl/BigHierarchyMultipicklistNew';


function BigHierarchyMultipicklistControl({
  className,
  classes,
  error,
  helperText,
  testName,
  options,
  onChange,
  value,
  searchLabel,
  iconMapper,
  isLegacy,
  hasSearch,
  ...rest
}) {
  const [searchTerm, setSearchTerm] = React.useState('');

  const groups = React.useMemo(() => {
    const map = {};
    options.forEach(el => {
      const before = map[el.attr('group')] || [];
      map[el.attr('group')] = [...before, {
        resource: el,
        description: el.attr('description'),
        matchesSearchTerm: !searchTerm ? true : el.attr('prompt').toLowerCase().includes(searchTerm),
      }];
    });
    return map;
  }, [options, searchTerm]);

  const handleMultipleChange = (optionValue, selected) => {
    const updatedValue = value.filter((v) => {
      return v !== optionValue; // Start by removing option from selected
    });

    if (selected) {
      return [...updatedValue, optionValue];
    }

    return updatedValue;
  };

  const handleSearchDebounced = useDebounce((v) => {
    setSearchTerm(v.toLowerCase());
  }, 250);

  if (isLegacy) {
    return (<BigHierarchyMultipicklistLegacy
      className={className}
      classes={classes}
      error={error}
      helperText={helperText}
      testName={testName}
      onChange={onChange}
      value={value}
      iconMapper={iconMapper}
      handleSearchDebounced={handleSearchDebounced}
      groups={groups}
      searchLabel={searchLabel}
      handleMultipleChange={handleMultipleChange}
      {...rest}
    />);
  }

  return (
    <BigHierarchyMultipicklistNew
      testName={testName}
      onChange={onChange}
      value={value}
      iconMapper={iconMapper}
      handleSearchDebounced={handleSearchDebounced}
      groups={groups}
      handleMultipleChange={handleMultipleChange}
      searchLabel={searchLabel}
      hasSearch={hasSearch}
    />
  );
}

BigHierarchyMultipicklistControl.defaultProps = {
  className: '',
  searchLabel: 'Search',
  iconMapper: noop,
  isLegacy: true,
  hasSearch: true,
};

BigHierarchyMultipicklistControl.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  testName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]).isRequired,
  searchLabel: PropTypes.string,
  hasSearch: PropTypes.bool,
  iconMapper: PropTypes.func,
  isLegacy: PropTypes.bool,
};

export default BigHierarchyMultipicklistControl;
